import styled from 'styled-components';

export const ToastLoaderWrapper = styled.span`
  display: inline-flex;
  gap: 6px;
  align-items: center;
`;
